module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie-9.8bb6f854.jpg";